import { hexToRGB } from './hex-to-rgb';

export function getTextContrast(hex: string): 'black' | 'white' {
	const { r, g, b } = hexToRGB(hex);
	const lum = (r * 299 + g * 587 + b * 114) / 1000;

	return lum >= 80 ? 'black' : 'white';
}
